import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { DataGridContainer, FullDivider } from '../../../../../ui/styled';
import ComplianceDialog from './ComplianceDialog/ComplianceDialog';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import { dateFormat } from '../../../../../../constants';
import {
  getOrganizationComplianceListForm,
  newOrganizationComplianceListForm,
} from '../../../../../../redux/organization/organizationTabs/organizationCompliance/organizationComplianceList/organizationComplianceDataSlice';
import {
  GridContainer,
  LeftGrid,
  NoteHeading,
} from '../../../../../Episode/Episode.Styled';

const ComplianceList = (props) => {
  const { orgId, complianceDataList } = props;
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [openComplianceDialog, setOpenComplianceDialog] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [complianceData, setComplianceData] = useState({
    isLoading: false,
    data: [],
    total: 0,
    // page: 1,
    // pageSize: 10,
    // sortModel: '',
  });

  const organizationReferenceData = useSelector(
    (state) => state.organizationReferenceData
  );
  const { complianceCategoryList } = organizationReferenceData;

  const getComplianceCategoryName = (complianceId) => {
    const getComplianceCategory = complianceCategoryList.find(
      (item) => item.cplTypId === complianceId
    );
    return getComplianceCategory.cplTypCat;
  };

  const getComplianceDescriptionName = (complianceId) => {
    const getComplianceDescription = complianceCategoryList.find(
      (item) => item.cplTypId === complianceId
    );
    return getComplianceDescription.cplTypDsc;
  };

  useEffect(() => {
    getUser().then((userData) => setUser(userData));
  }, []);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  useEffect(() => {
    getComplianceDataList();
  }, [complianceDataList]);

  const getComplianceDataList = () => {
    setComplianceData((prveState) => ({ ...prveState, isLoading: true }));
    const json = complianceDataList;
    setComplianceData((prveState) => ({
      ...prveState,
      isLoading: false,
      data: json?.map((item, index) => ({
        ...item,
        _id: index,
        cplId: item.cplId,
        cplOrgId: item.cplOrgId,
        complianceCategory: getComplianceCategoryName(item.complianceCategory),
        complianceCategoryId: item.complianceCategory,
        complianceDescription: getComplianceDescriptionName(
          item.complianceDescription
        ),
        complianceDescriptionId: item.complianceDescription,
        startDate: item.startDate
          ? moment(item.startDate).format(dateFormat).split('T')[0]
          : '-',
        endDate: item.endDate
          ? moment(item.endDate).format(dateFormat).split('T')[0]
          : '-',
        description: item.description,
        ReferenceNumber: item.ReferenceNumber,
      })),
    }));
  };

  const updateCompliance = (params) => {
    const { row } = params;
    const organizationComplianceListForm = {
      cplId: row?.cplId,
      ReferenceNumber: row?.ReferenceNumber,
      complianceCategoryId: row?.complianceCategoryId,
      complianceDescriptionId: row?.complianceDescriptionId,
      cplOrgId: row?.cplOrgId,
      description: row?.description,
      startDate: row?.startDate,
      endDate: row?.endDate,
    };
    dispatch(getOrganizationComplianceListForm(organizationComplianceListForm));
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 1000);
    setOpenComplianceDialog(true);
  };

  const handelNewOrganizationComplianceForm = () => {
    const newOrganizationComplianceListData = {
      newOrganizationComplianceListForm: true,
      cplId: 0,
      ReferenceNumber: null,
      complianceCategoryId: null,
      complianceDescriptionId: null,
      cplOrgId: orgId,
      description: null,
      startDate: null,
      endDate: null,
    };
    dispatch(
      newOrganizationComplianceListForm(newOrganizationComplianceListData)
    );
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 1000);
    setOpenComplianceDialog(true);
  };

  const columnsData = [
    {
      field: 'cplId',
      headerName: 'Compliance ID',
      renderCell: (params) => {
        return (
          <Typography
            variant='h6'
            style={{
              width: '100%',
              cursor: 'pointer',
              fontSize: '15px',
              color: '#0000FF',
            }}
            onClick={() => updateCompliance(params)}
          >
            {params.row.cplId}
          </Typography>
        );
      },
      flex: 1,
    },
    { field: 'complianceCategory', headerName: 'Compliance Category', flex: 1 },
    {
      field: 'complianceDescription',
      headerName: 'Compliance Description',
      flex: 1,
    },
    { field: 'startDate', headerName: 'Start date', type: 'date', flex: 1 },
    { field: 'endDate', headerName: 'End Date', type: 'date', flex: 1 },
    { field: 'ReferenceNumber', headerName: 'Reference Number', flex: 1 },
    { field: 'description', headerName: 'Description', flex: 1 },
  ];

  const getTitleAndButton = () => {
    return (
      <>
        <FullDivider />
        <GridContainer container>
          <Grid item xs={6}>
            <NoteHeading variant='h5'>
              To edit Compliance please click on Compliance Id
            </NoteHeading>
          </Grid>
          <LeftGrid item xs={6}>
            <Button
              variant='contained'
              onClick={() => handelNewOrganizationComplianceForm()}
            >
              New Compliance
            </Button>
          </LeftGrid>
        </GridContainer>
      </>
    );
  };

  const getDataGrid = () => {
    return (
      <DataGridContainer>
        <DataGrid
          getRowHeight={() => 'auto'}
          columns={columnsData}
          rows={complianceData.data}
          // pageSize={contactList.pageSize}
          // page={contactList.page - 1}
          rowCount={complianceData.total}
          getRowId={(row) => row._id}
          // paginationMode='server'
          // sortingMode='server'
          // onPageSizeChange={(newPageSize) =>
          //   setContactList((old) => ({ ...old, pageSize: newPageSize }))
          // }
          // onPageChange={(newPage) => {
          //   setContactList((old) => ({ ...old, page: newPage + 1 }));
          // }}
          // rowsPerPageOptions={paginationSize}
          //pagination
          //components={{ Toolbar: QuickSearchToolbar }}
          experimentalFeatures={{ newEditingApi: true }}
          //onSortModelChange={handleSortModelChange}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
          }
          loading={complianceData.isLoading}
        />
      </DataGridContainer>
    );
  };

  const getOrganizationComplianceDialogDialog = () => {
    return (
      <>
        <ComplianceDialog
          open={openComplianceDialog}
          setOpen={setOpenComplianceDialog}
          authToken={user?.signInUserSession.accessToken.jwtToken}
          openBackdrop={openBackdrop}
        />
      </>
    );
  };

  return (
    <>
      {getTitleAndButton()}
      {getDataGrid()}
      {getOrganizationComplianceDialogDialog()}
    </>
  );
};

export default ComplianceList;
